export default "__VITE_ASSET__iCnPmgDr__"